var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInActiveDocumentTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.994 24H0.523793C0.23452 24 0 23.7655 0 23.4762V0.523793C0 0.23445 0.23452 0 0.523793 0H19.994C20.2832 0 20.5178 0.23445 20.5178 0.523793V23.4762C20.5178 23.7655 20.2832 24 19.994 24ZM1.04759 22.9524H19.4702V1.04759H1.04759V22.9524Z",
    fill: "#8D90A5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3532 5.34349H4.16454C3.87527 5.34349 3.64075 5.10897 3.64075 4.81969C3.64075 4.53035 3.87527 4.2959 4.16454 4.2959H16.3532C16.6425 4.2959 16.877 4.53035 16.877 4.81969C16.877 5.10897 16.6425 5.34349 16.3532 5.34349Z",
    fill: "#8D90A5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.3532 8.07347H4.16454C3.87527 8.07347 3.64075 7.83902 3.64075 7.54967C3.64075 7.26033 3.87527 7.02588 4.16454 7.02588H16.3532C16.6425 7.02588 16.877 7.26033 16.877 7.54967C16.877 7.83902 16.6425 8.07347 16.3532 8.07347Z",
    fill: "#8D90A5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.3532 10.8034H4.16454C3.87527 10.8034 3.64075 10.569 3.64075 10.2797C3.64075 9.99031 3.87527 9.75586 4.16454 9.75586H16.3532C16.6425 9.75586 16.877 9.99031 16.877 10.2797C16.877 10.569 16.6425 10.8034 16.3532 10.8034Z",
    fill: "#8D90A5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.3532 13.5334H12.813C12.5237 13.5334 12.2892 13.299 12.2892 13.0096C12.2892 12.7203 12.5237 12.4858 12.813 12.4858H16.3532C16.6425 12.4858 16.877 12.7203 16.877 13.0096C16.877 13.299 16.6425 13.5334 16.3532 13.5334Z",
    fill: "#8D90A5"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.77599 21.6518L8.61575 17.6314C9.13466 17.1326 9.45857 16.4323 9.45857 15.6574C9.45857 14.1466 8.2294 12.9175 6.71864 12.9175C5.20788 12.9175 3.97878 14.1466 3.97878 15.6574C3.97878 16.4323 4.3027 17.1326 4.8216 17.6315L3.66129 21.6518C3.60277 21.8548 3.67177 22.073 3.83638 22.2053C3.93143 22.2818 4.04764 22.3209 4.16462 22.3209C4.25018 22.3209 4.33608 22.2999 4.41451 22.2574L6.71871 21.0062L9.02291 22.2574C9.10127 22.2999 9.18724 22.3209 9.27273 22.3209C9.38978 22.3209 9.50599 22.2818 9.60104 22.2053C9.76558 22.073 9.83458 21.8549 9.77599 21.6518ZM6.71871 13.9651C7.65183 13.9651 8.41105 14.7243 8.41105 15.6574C8.41105 16.5905 7.65183 17.3496 6.71871 17.3496C5.78559 17.3496 5.02644 16.5905 5.02644 15.6574C5.02637 14.7243 5.78552 13.9651 6.71871 13.9651ZM6.9686 19.95C6.8081 19.8629 6.62226 19.8685 6.47225 19.9483C6.47106 19.9489 6.46987 19.9494 6.46876 19.95L5.01506 20.7393L5.74299 18.2171C6.0463 18.3331 6.3751 18.3973 6.71871 18.3973C7.06232 18.3973 7.39112 18.3331 7.69443 18.2171L8.42237 20.7393L6.9686 19.95Z",
    fill: "#8D90A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActiveDocumentTab);
export default __webpack_public_path__ + "static/media/inActiveDocumentTab.e28b677ece407369ca1e89175668eea0.svg";
export { ForwardRef as ReactComponent };